export default __webpack_public_path__ + "static/media/TT Norms Pro ExtraLight.f09c9bd9.otf";